import cityInvoiceConfiguration from "./cityInvoiceConfiguration.component";

const cityInvoiceConfigurationModule = angular
  .module("app.components.cityInvoiceConfiguration", [])
  .component("cityInvoiceConfiguration", cityInvoiceConfiguration);

export default cityInvoiceConfigurationModule;



// WEBPACK FOOTER //
// ./src/components/cityInvoiceConfiguration/cityInvoiceConfiguration.module.js